import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

const colors = ["#5662be", "#7a86df", "#efc58a"];

const data = [
  { date: "Jan", reports: 30 },
  { date: "Feb", reports: 45 },
  { date: "Mar", reports: 25 },
  { date: "Apr", reports: 50 },
  { date: "May", reports: 40 },
];

const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 5;

  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill}
    />
  );
};

const TotalReportAnalysis = () => {
  return (
    <div className="report-chart-container" style={{ width: '100%' }}>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 10, right: 0, left: 0, bottom: 20 }}>
          <CartesianGrid stroke="#d6d6d6" strokeDasharray="0 0" horizontal vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 14, fill: "#999" }}>
            <Label value="Time Period" position="insideLeft" offset={0} dy={25} style={{ fontSize: "14px", fill: "#999" }} />
          </XAxis>

          <Tooltip cursor={{ fill: "transparent" }} formatter={(value) => [`${value}`, "Reports Count"]} />
          <Bar
            dataKey="reports"
            barSize={25}
            shape={(props) => {
              const index = data.findIndex((d) => d.reports === props.payload.reports);
              return <CustomBar {...props} fill={colors[index % colors.length]} />;
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TotalReportAnalysis;
